import eventBus from '../../eventBus';
import { signoutEvent } from '../../eventBus/appEventTypes';
import { HeaderName } from '../HeaderName';
const XML_HTTP_REQUEST = 'XMLHttpRequest';
// eslint-disable-next-line @sas/i18n/jsx-to-localize
const AUTHENTICATION = 'authentication';
const isSameOrigin = url => {
  if (url === null || url === undefined) return false;
  // Calling the URL constructor will use the window's origin if no origin is in the url string.
  // This is intended to cleanly check relative URLs without having account for the different ways
  // you can define one.
  return window.location.origin === new URL(url, window.location.origin).origin;
};
export const addRequestedWithHeader = config => {
  if (isSameOrigin(config.url) && !config.headers[HeaderName.RequestedWith]) {
    config.headers[HeaderName.RequestedWith] = XML_HTTP_REQUEST;
  }
  return config;
};
export const verifyAuthentication = err => {
  const status = err.response?.status;
  if (isSameOrigin(err.request?.responseURL) && status && status >= 300 && err.response?.headers[HeaderName.UnauthorizedReason.toLowerCase()]?.toLowerCase() === AUTHENTICATION) {
    eventBus.publish(signoutEvent);
  }
  return Promise.reject(err);
};
//# sourceMappingURL=requested-with.js.map